import 'construct-style-sheets-polyfill'; const styleSheet = new CSSStyleSheet(); styleSheet.replaceSync(`.tooltip {
    position: relative;
    display: inline-block;
}

.tooltip .tooltip-content {
    visibility: hidden;
    background: linear-gradient(0deg, #ffffff, #ffffff), #ffffff;
    max-width: 11em;
    min-width: 5em;
    color: #6d809c;
    border-radius: 0.8em;
    padding: 0.9em;
    position: absolute;
    z-index: 1;
    bottom: 3em;
    margin-left: -2em;
    opacity: 0;
    transition: opacity 0.3s;
    box-shadow: 0px 0px 0.75em rgba(0, 0, 0, 0.2);
}

.tooltip .tooltip-content::after {
    content: '';
    width: 1.6em;
    height: 1.6em;
    position: absolute;
    left: 2em;
    background: #ffffff;
    box-shadow: 0.15em 0.15em 0.2em rgba(0, 0, 0, 0.14);
    transform: rotate(45deg);
}

.tooltip:hover .tooltip-content {
    visibility: visible;
    opacity: 1;
}
`); export default styleSheet;